<template>
  <BContainer
    class="p-0 py-2"
    fluid
  >
    <ValidationObserver
      ref="formInformation"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Cluster"
              label-for="fCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fCluster"
                v-model="formInformation.cluster_name"
                placeholder="no cluster"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="9"
          >
            <BFormGroup
              label="Lead Name"
              label-for="fLeadName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fLeadName"
                v-model="formInformation.lead_name"
                rows="2"
                max-rows="4"
                placeholder="no lead name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            class="py-2"
          >
            <div class="border-bottom" />
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Contact Person"
              label-for="fContactPerson"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fContactPerson"
                v-model="formInformation.contact_person"
                placeholder="no contact person"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Mobile Number"
              label-for="fMobileNumber"
              label-class="font-weight-bolder"
              description="Only if lead has network coverage"
              class="mb-2"
            >
              <BFormInput
                id="fMobileNumber"
                v-model="formInformation.mobile_number"
                placeholder="no mobile number"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Email"
              label-for="fEmail"
              label-class="font-weight-bolder"
              description="Only if lead has an email."
              class="mb-2"
            >
              <BFormInput
                id="fEmail"
                v-model="formInformation.email"
                placeholder="no email"
                type="email"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Address"
              label-for="fAddress"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fAddress"
                v-model="formInformation.address"
                rows="5"
                max-rows="12"
                maxlength="1000"
                placeholder="no address"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Other Informations"
              label-for="fRemarks"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fRemarks"
                v-model="formInformation.remarks"
                rows="5"
                max-rows="12"
                maxlength="1000"
                placeholder="no other informations"
                disabled
              />
            </BFormGroup>
          </BCol>

        </BRow>
      </form>
    </ValidationObserver>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'

import { SASMLead } from '@/services/asm'

export default {
  name: 'VASMLeadInformations',

  mixins: [
    MxMisc
  ],

  emits: ['updated'],

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        dateFormat: 'Y-m-d'
      },
      state: {
        busy: false,
        editing: false
      },
      selected: {
        tagging: 1
      },
      fetching: {
        gender: false
      },
      options: {
        gender: ['Male', 'Female'],
        yesOrNos: [
          {
            text: 'No',
            value: '0'
          },
          {
            text: 'Yes',
            value: '1'
          }
        ]
      },
      formInformation: {
        id: '',
        cluster_id: '',
        cluster_name: '',
        lead_name: '',
        contact_person: '',
        email: '',
        mobile_number: '',
        address: '',
        remarks: '',
        status: 'Verified',
        active: 1
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    isVerified () {
      return this.formInformation.status === 'Verified'
    }
  },

  methods: {

    isFetchingLocations () {
      return this.fetching.provinces || this.fetching.municipalities || this.fetching.barangays
    },

    setInformation (lead) {
      this.formInformation = Object.assign(this.formInformation, lead)
    },

    getInformation () {
      return this.formInformation
    },

    async showInformation (leadID) {
      return await SASMLead.show(leadID).then(
        ({ data: { lead } }) => lead
      )
    },

    async createInformation () {
      this.state.editing = false

      this.formInformation = Object.assign(this.formInformation, {
        id: '',
        cluster_id: '',
        cluster_name: '',
        lead_name: '',
        contact_person: '',
        email: '',
        mobile_number: '',
        address: '',
        remarks: '',
        active: 1
      })
    },

    async editInformation (lead) {
      this.state.editing = true

      this.formInformation = Object.assign(this.formInformation, {
        id: lead.id,
        cluster_id: lead.cluster_id,
        cluster_name: lead.cluster?.cluster_name,
        lead_name: lead.lead_name,
        contact_person: lead.contact_person,
        email: lead.email,
        mobile_number: lead.mobile_number,
        address: lead.address,
        remarks: lead.remarks,
        active: lead.active,
        status: 'Verified'
      })
    },

    async validateInformation () {
      return new Promise((resolve, reject) => {
        this.$refs.formInformation.validate().then(
          isFormValid => {
            if (isFormValid) {
              return resolve(isFormValid)
            }

            return reject(new Error('Invalid Form'))
          }
        )
      })
    },

    async submitInformation () {
      return new Promise(resolve => {
        this.validateInformation().then(
          () => {
            this.swalConfirm({
              html: this.state.editing ? 'Update this Lead?' : 'Register this Lead?',
              confirmButtonText: this.state.editing ? 'Update' : 'Register',
              cancelButtonText: 'Discard',
              preConfirm: async () => {
                this.state.busy = true

                const createOrUpdate = () => {
                  return this.state.editing ? this.putInformation() : this.postInformation()
                }

                return createOrUpdate().catch(
                  ({ message }) => {
                    if (message && message?.errors) {
                      this.$refs.formInformation.setErrors(message?.errors)
                    }
                  }
                ).finally(() => {
                  this.state.busy = false
                })
              }
            }).then(resolve)
          }
        ).catch(() => {
          this.swalInvalid()
        })
      })
    },

    async postInformation () {
      return await SASMLead.post(this.formInformation).then(
        ({ data }) => data
      )
    },

    async putInformation () {
      return await SASMLead.put(this.formInformation).then(
        ({ data }) => data
      )
    },

    setErrors (errors) {
      if (errors) {
        this.$refs.formInformation.setErrors(errors)
      }
    }
  }
}
</script>
